import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { Module, Stack } from "types/generated";
import { hasAtLeastWriteAccess } from "utils/access";

// FYI: the "stack.canWrite" check here is for legacy stacks/modules (could be affected by access policies)
const useHasEntityWriteAccess = (): ((
  entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>
) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (entity?: Partial<Pick<Stack | Module, "canWrite" | "spaceDetails" | "space">>) => {
      if (!entity) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      if (entity.canWrite) {
        return true;
      }

      return hasAtLeastWriteAccess(viewer, entity.spaceDetails?.id || entity.space);
    },
    [viewer]
  );
};

export default useHasEntityWriteAccess;
